import axios from 'axios'
const { VUE_APP_API_URL } = process.env

const loadBaggageAllowance = async (data) => {
  try {
    const type = data.single ? 'single' : 'multi'
    const hand = (data.hand) ? '?type=hand' : ''
    const url = `${VUE_APP_API_URL}/api/v01/baggage/process/${type}${hand}`
    const res = await axios.post(url, data)
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

export {
  loadBaggageAllowance
}
